import { Switch } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Controller } from 'react-hook-form'

const containerStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '12px',
  lineHeight: 1
}

const labelStyle = {
  fontSize: '13px',
  margin: 0,
  fontWeight: '400'
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#5952E0',
      opacity: 1,
      '& + .MuiSwitch-track': {
        opacity: 0.5,
        backgroundColor: '#5952E0',
        ...theme.applyStyles('dark', {
          backgroundColor: '#5952E0',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    })
  },
}))

/** Customised Material UI switch component */
const CustomSwitch = ({
  id,
  name,
  label,
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  readOnly = false,
  fixedWidth,
  labelPosition = 'right',
  className = '',
  ariaLabel,
  control
}) => {
  const hasLabel = Boolean(label)
  const showFixedWidth = labelPosition === 'left' && fixedWidth
  const isDisabled = disabled || readOnly

  const labelStyles = {
    ...labelStyle,
    maxWidth: showFixedWidth ? '300px' : undefined,
    minWidth: showFixedWidth ? '300px' : undefined,
    opacity: isDisabled ? 0.5 : 1
  }

  const labelElement = hasLabel ? (
    <label htmlFor={id} style={labelStyles}>
      {label}
    </label>
  ) : null

  const renderSwitch = (fieldChecked, fieldOnChange) => (
    <div style={{ ...containerStyle, gap: hasLabel ? '12px' : 0 }} className={className}>
      {labelPosition === 'left' && labelElement}
      <StyledSwitch
        id={id}
        checked={fieldChecked}
        defaultChecked={defaultChecked}
        onChange={fieldOnChange}
        disabled={isDisabled}
        size='small'
        slotProps={{ 'aria-label': ariaLabel || label || id }}
      />
      {labelPosition !== 'left' && labelElement}
    </div>
  )

  if (control) {
    return (
      <Controller
        name={name || id}
        control={control}
        render={({ field }) => renderSwitch(Boolean(field.value), (_, val) => field.onChange(val))}
      />
    )
  }

  return renderSwitch(checked, onChange)
}

export default CustomSwitch
